import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=cbcd0ece&"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbcd0ece')) {
      api.createRecord('cbcd0ece', component.options)
    } else {
      api.reload('cbcd0ece', component.options)
    }
    module.hot.accept("./AppBreadcrumb.vue?vue&type=template&id=cbcd0ece&", function () {
      api.rerender('cbcd0ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppBreadcrumb/AppBreadcrumb.vue"
export default component.exports